import { render, staticRenderFns } from "./court-info-inquiry.vue?vue&type=template&id=36d18cfa"
import script from "./court-info-inquiry.vue?vue&type=script&lang=ts"
export * from "./court-info-inquiry.vue?vue&type=script&lang=ts"
import style0 from "./court-info-inquiry.vue?vue&type=style&index=0&id=36d18cfa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports